import React from "react";
import { motion } from "framer-motion";

const SOLUTIONS = [
  {
    n: "S/01",
    title: "Growth Engine",
    body: "Marketing + automation working as one compounding system.",
    tags: ["Performance", "Lifecycle", "AI Personalization"],
  },
  {
    n: "S/02",
    title: "Launch Sprint",
    body: "Idea to live product, fast, design-led.",
    tags: ["Design", "Build", "Launch"],
  },
  {
    n: "S/03",
    title: "Automate & Scale",
    body: "Map your workflows, then let AI run them.",
    tags: ["AI Agents", "RPA", "Integrations"],
  },
];

const Card = ({ s, i }) => (
  <motion.div
    data-testid={`solution-card-${i}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
    className="group relative p-8 md:p-10 bg-surface hairline rounded-[2px] overflow-hidden"
  >
    <div
      aria-hidden
      className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700"
      style={{
        background: "linear-gradient(135deg, rgba(110,91,255,0.10), rgba(0,224,255,0.06) 60%, transparent)",
      }}
    />
    <div className="relative">
      <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">{s.n}</span>
      <h3
        className="mt-6 font-display font-medium tracking-tight text-[#0a0a0b] leading-none transition-transform duration-500 group-hover:-translate-y-1"
        style={{ fontSize: "clamp(1.8rem, 2.8vw, 2.6rem)" }}
      >
        {s.title}
      </h3>
      <p className="mt-4 text-base text-muted-ink">{s.body}</p>
      <div className="mt-8 flex flex-wrap gap-2">
        {s.tags.map((t) => (
          <span key={t} className="text-[10px] tracking-[0.25em] uppercase text-[#0a0a0b] px-3 py-1 hairline rounded-full">
            {t}
          </span>
        ))}
      </div>
      <div
        className="mt-8 h-px w-0 group-hover:w-full transition-[width] duration-700 accent-gradient"
        aria-hidden
      />
    </div>
  </motion.div>
);

const Solutions = () => (
  <section
    id="solutions"
    data-testid="solutions-section"
    className="relative px-6 md:px-12 lg:px-20 py-32 md:py-40"
  >
    <div className="flex items-end justify-between mb-12 md:mb-16 flex-wrap gap-6">
      <div className="flex items-center gap-4">
        <span className="h-px w-12 bg-[#0a0a0b]/30" />
        <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">03 — Solutions</span>
      </div>
      <h2
        className="font-display font-medium tracking-tight leading-none text-[#0a0a0b]"
        style={{ fontSize: "clamp(2rem, 4.5vw, 4rem)" }}
      >
        Packaged for <span className="accent-text">outcomes.</span>
      </h2>
    </div>
    <div className="grid md:grid-cols-3 gap-6 md:gap-8">
      {SOLUTIONS.map((s, i) => (
        <Card key={s.n} s={s} i={i} />
      ))}
    </div>
  </section>
);

export default Solutions;
